import { createWebHistory, createRouter } from "vue-router";
import TheHome from "@/views/TheHome.vue";

const routes = [
    {
        path: "/",
        name: "Home",
        component: TheHome,
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;